/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionstatusmissed2Inputs */

const en_actionstatusmissed2 = /** @type {(inputs: Actionstatusmissed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not sent – over before 8 am`)
};

const de_actionstatusmissed2 = /** @type {(inputs: Actionstatusmissed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht verschickt – vor 8 Uhr vorbei`)
};

/**
* | output |
* | --- |
* | "Not sent – over before 8 am" |
*
* @param {Actionstatusmissed2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionstatusmissed2 = /** @type {((inputs?: Actionstatusmissed2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionstatusmissed2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionstatusmissed2(inputs)
	return de_actionstatusmissed2(inputs)
});
export { actionstatusmissed2 as "actionStatusMissed" }